import { Component, OnInit, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { FoodService } from 'app/services';

@Component({
    selector: 'edit-food-category',
    templateUrl: './edit-food-category.component.html',
    styleUrls: ['./edit-food-category.component.scss'],
    providers: [MessageService]
})
export class EditFoodCategoryComponent implements OnInit {
    @Input()
    public categoryId: number = 0;

    @Input()
    public onSave: () => void = () => { };

    @Input()
    public onHide: () => void = () => { };

    public category: any = {};

    constructor(
        private messageService: MessageService,
        private foodService: FoodService) {
    }

    ngOnInit(): void {
        if (this.categoryId) {
            this.getCategory();
        }
    }

    private getCategory(): void {
        const dto = {
            Id: this.categoryId
        };

        this.foodService.getCategoryById(dto, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.category = data;
            });
    }

    public handleUploadClick(): void {
        document.getElementById('idImgInput')?.click();
    }

    public handleImageChange(event: Event) {
        const target = event.target as HTMLInputElement;

        let file: File | null = null;

        if (target.files) {
            file = target.files[0];
        }

        if (!file) {
            return;
        }

        // Chech max file size 2MB
        if (file.size > 2097152) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'This file is bigger than 2MB.' });
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            if (e?.target?.result) {
                // Base64 string
                this.category.ImageUrl = e.target.result.toString();
            }
        };

        reader.readAsDataURL(file);
    }

    public handleSideBarHide(): void {
        this.onHide();
    }

    public handleSaveClick(): void {
        let promise: Promise<any> = Promise.resolve();

        if (this.categoryId) {
            promise = this.foodService.updateCategory(this.category, this.messageService);
        } else {
            promise = this.foodService.addCategory(this.category, this.messageService);
        }

        promise.then(data => {
            if (!data) {
                return;
            }

            if (!data.Success) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }

            this.onSave();
        });
    }
}
